import { formatDateLong } from '../lib/DateTime.js';
import React from 'react';
import useBusinessNavigate from '../lib/useBusinessNavigate.js';
import { differenceInDays } from 'date-fns';
import { useFreeBusinessExceededLimits } from '~/lib/BusinessHelpers.js';

const Banner = ({ children, backgroundClassName, linkClassName }) => {
    const navigate = useBusinessNavigate();

    return (
        <div
            onClick={() => navigate('/settings/billing')}
            className={`cursor-pointer fixed bottom-0 z-[5] p-4 flex flex-wrap gap-2 sm:gap-0 items-center justify-center w-full text-center ${backgroundClassName ? backgroundClassName : 'bg-primary-100'} text-sm`}
        >
            {children}

            <span className={`btn-pill ml-4 no-underline ${linkClassName}`}>
                Upgrade Now
            </span>
        </div>
    );
};

const TrialBanner = ({ business, businessData }) => {
    const { isExceeded, overage } = useFreeBusinessExceededLimits();

    if (!!business?.is_trial) {
        return (
            <Banner>
                You are currently on a trial that expires{' '}
                {formatDateLong(business?.expires_at)}
            </Banner>
        );
    }

    if (
        business?.plan === 'free' &&
        !!business?.expired_at &&
        differenceInDays(new Date(), new Date(business?.expired_at)) < 14
    ) {
        return (
            <Banner backgroundClassName="bg-yellow-100">
                Your account expired {formatDateLong(business?.expired_at)}
            </Banner>
        );
    }

    if (isExceeded) {
        const isWayOver = overage > 5;
        return (
            <Banner
                backgroundClassName={isWayOver ? 'bg-rose-500 text-white' : null}
                linkClassName={isWayOver ? '!text-rose-500 !bg-white hover:!bg-white/90' : '!text-white-500'}
            >
                You have reached the max number of clients allowed on the free
                plan. {isWayOver ? 'Forms are disabled.' : 'Forms will be disabled.'} Please upgrade.
            </Banner>
        );
    }
};

export default TrialBanner;
